import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import Cookies from 'js-cookie'

let store = (set) => ({
  student: {},
  // store student count
  studentCount: 0,
  students: {},
  getstudent: async () => {
    let token = Cookies.get('token')
    const id = Cookies.get('type')?.substring(40)?.split(',')?.[0] ?? -1

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/student/${id}`,
      config
    )
    set(async (state) => {
      state.student = apiResponse.data
    })
  },
  getStudentCount: async () => {
    // setting token
    let token = Cookies.get('token')

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      }
    }
    // setting url 
    // main url comes from .env file
    const apiResponse = await axios.get(`${process.env.REACT_APP_API}/student/getcount`, config)
    set(async (state) => {
      // initilize students state variable to the responsed students if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.studentCount = apiResponse?.data?.student ?? ''
    })
  },
  getstudents: async () => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'student.id',
        orderBy: 'desc',
      },
    }
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/student`,
      config
    )
    set(async (state) => {
      state.students = apiResponse.data
    })
  },
  getStudentsReport: async () => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      params: {
        sortBy: 'student.id',
        orderBy: 'desc',
      },
    }
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/student/report/all`,
      config
    )
    set(async (state) => {
      state.students = apiResponse.data
    })
  },
  addStudent: async (payload) => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
    const apiResponse = await axios.post(
      `${process.env.REACT_APP_API}/studentauth/studentregister`,
      payload,
      config
    )
    if (apiResponse?.status === 201 || apiResponse?.status === 200) {
      set(async (state) => {
        state.students = {
          data: [apiResponse?.data?.student ?? {}, ...state.students.data],
          limit: state.students.limit,
          page: state.students.page,
          totalCount: state.students.totalCount + 1,
        }
      })
    }
    return apiResponse
  },
  loginStudent: async (payload) => {
    const apiResponse = await axios.post(
      `${process.env.REACT_APP_API}/studentauth/studentlogin`,
      payload
    )
    if (apiResponse?.status === 201 || apiResponse?.status == 200) {
      set(async (state) => {
        state.student = apiResponse?.data?.student ?? ''
        // state.student.token = apiResponse?.data?.token ?? 'null'

        const studentResult = apiResponse?.data?.student ?? ''
        const studentId = studentResult?.id ?? ''
        let majorId = studentResult?.majors?.[0] ?? ''
        let cohortId = studentResult?.cohorts?.[0] ?? ''
        const token = apiResponse?.data?.token ?? ''

        majorId = JSON.stringify(majorId)
        cohortId = JSON.stringify(cohortId)
        Cookies.set('token', token, {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
        Cookies.set('type', process.env.REACT_APP_STL+ studentId + ',', {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })

        Cookies.set('major', majorId, {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
        Cookies.set('cohort', cohortId, {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })

        Cookies.set('image', studentResult?.image ?? '', {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
        Cookies.set('name', studentResult?.name ?? '', {
          httpOnly: false,
          expires: 1,
          secure: true,
          sameSite: 'strict',
          path: '/',
        })
      })
    }
    return apiResponse?.data ?? ''
  },
  logoutStudent: async () => {
    set(async (state) => {
      state.student = {}
      Cookies.set('token', '', {
        httpOnly: false,
        expires: 1,
        secure: true,
        sameSite: 'strict',
        path: '/',
      })
      Cookies.set('type', '', {
        httpOnly: false,
        expires: 1,
        secure: true,
        sameSite: 'strict',
        path: '/',
      })
    })
  },
  putstudent: async (payload, id) => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    const apiResponse = await axios.patch(
      `${process.env.REACT_APP_API}/student/${id}`,
      payload,
      config
    )
    if (apiResponse?.status === 200 || apiResponse?.status === 201) {
      set(async (state) => {
        if (state?.students?.data?.length ?? 0 > 0) {
          for (let index = 0; index < state.students.data.length; index++) {
            const element = state.students.data[index]
            if (element.id == id) {
              state.students.data[index] = apiResponse.data
              state.students = {
                data: [...state.students.data],
                limit: 1000,
                page: 1,
                totalCount: 156
              }

              if (state.student.id == state.students.data[index].id) {
                const token = state.student.token
                state.student = apiResponse.data
                state.student.token = token

                const studentResult = apiResponse?.data?.student ?? ''
                let major = studentResult?.majors?.[0] ?? ''
                let cohort = studentResult?.cohorts?.[0] ?? ''
                major = JSON.stringify(major)
                cohort = JSON.stringify(cohort)
                Cookies.set('major', major, {
                  httpOnly: false,
                  expires: 1,
                  secure: true,
                  sameSite: 'strict',
                  path: '/',
                })
                Cookies.set('cohort', cohort, {
                  httpOnly: false,
                  expires: 1,
                  secure: true,
                  sameSite: 'strict',
                  path: '/',
                })
              }
            }
          }
        } else {

          const studentResult = apiResponse?.data ?? ''
          state.student = studentResult
          let major = studentResult?.majors?.[0] ?? ''
          let cohort = studentResult?.cohorts?.[0] ?? ''
          major = JSON.stringify(major)
          cohort = JSON.stringify(cohort)
          Cookies.set('major', major, {
            httpOnly: false,
            expires: 1,
            secure: true,
            sameSite: 'strict',
            path: '/',
          })
          Cookies.set('cohort', cohort, {
            httpOnly: false,
            expires: 1,
            secure: true,
            sameSite: 'strict',
            path: '/',
          })
        }
      })
    }
    return apiResponse ?? ''
  },
  deletestudent: async (id) => {
    let token = Cookies.get('token')

    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }

    const apiResponse = await axios.delete(
      `${process.env.REACT_APP_API}/student/${id}`,
      config
    )
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const arr = state.students.data.filter((item) => item.id !== id)
        state.students = {
          data: arr,
          limit: state.students.limit,
          page: state.students.page,
          totalCount: state.students.totalCount - 1,
        }
      })
    }
  },
})

// store = persist(store, { name: 'student' })

const student_Store = create(store)

export default student_Store
